import React from 'react';
import PropTypes from 'prop-types';

import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

import {
  CardStyled,
  CardActionAreaStyled,
  CardContentStyled,
  DescriptionWrapper,
  ImageBackgroundStyled,
} from './styles';

export default function FeaturedCard({
  description,
  img,
  onClickFromSubathonFeatured,
  subtitle,
  title,
}) {
  return (
    <CardStyled>
      <CardActionAreaStyled onClick={onClickFromSubathonFeatured}>
        <CardContentStyled>
          <Typography variant="h4">{title}</Typography>
          {subtitle}
          <DescriptionWrapper>{description}</DescriptionWrapper>
        </CardContentStyled>
        <ImageBackgroundStyled>
          <CardMedia alt={img.imgAlt} component="img" image={img.imgUrl} />
        </ImageBackgroundStyled>
      </CardActionAreaStyled>
    </CardStyled>
  );
}

FeaturedCard.propTypes = {
  description: PropTypes.element,
  img: PropTypes.shape({
    imgAlt: PropTypes.string,
    imgUrl: PropTypes.string,
  }),
  onClickFromSubathonFeatured: PropTypes.func,
  subtitle: PropTypes.element,
  title: PropTypes.string,
};

FeaturedCard.defaultProps = {
  description: null,
  img: PropTypes.shape({
    imgAlt: '',
    imgUrl: '',
  }),
  onClickFromSubathonFeatured: undefined,
  subtitle: null,
  title: '',
};
